import { useEffect, useState } from 'react';
import TimeHelper from '../../../../utils/time';
import { IconButton, Menu, MenuItem } from '@mui/material';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { CommentCommand } from '../../../../services/command';
import Swal from 'sweetalert2';
import { CommentQuery } from '../../../../services/query';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { CRR_G } from '../commentRejectReason.classes';

const CommentRejectReasonTable = ({ setSelectedRejectReason, onDrawerOpen, refresh }: any) => {
    const { t } = useTranslation();
    const [rejectReasonDatas, setRejectReasonDatas] = useState([]);
    useEffect(() => {
        GetRejectReason();
    }, [refresh]);
    const handleDeleteRejectReason = async (id: any) => {
        const result = await Swal.fire({
            title: 'Ret nedenini silmek istediğinizden emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'Vazgeç',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });

        if (!result.isConfirmed) {
            return;
        }

        const req = { id: id };
        const res = await CommentCommand.DeleteRejectPhotoReason(req);
        if (res) {
            await Swal.fire(t('general.success'), 'Silindi', 'success');
            GetRejectReason();
        }
    };

    const columns = [
        {
            field: 'reasonForRejection',
            headerName: t('commentDetail.rejectReason'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
        },
        {
            field: 'createDate',
            headerName: t('commentDetail.createdDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'updateDate',
            headerName: t('commentDetail.updatedDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'deneme ',
            headerName: '',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            maxWidth: 50,
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'edit': {
                            setSelectedRejectReason(params.row);
                            onDrawerOpen();
                            break;
                        }
                        case 'delete': {
                            handleDeleteRejectReason(params.row.id);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <>
                                <IconButton className={CRR_G.rowMenuButton} {...bindTrigger(popupState)}>
                                    <MoreVertIcon className="svg_icons" />
                                </IconButton>
                                <Menu
                                    {...bindMenu(popupState)}
                                    slotProps={{ paper: { className: CRR_G.rowMenuPaper } }}
                                >
                                    <MenuItem
                                        className={CRR_G.rowMenuItemEdit}
                                        onClick={() => handleClick(popupState, 'edit')}
                                    >
                                        {t('general.edit')}
                                    </MenuItem>
                                    <MenuItem
                                        className={CRR_G.rowMenuItemDelete}
                                        onClick={() => handleClick(popupState, 'delete')}
                                    >
                                        {t('general.delete')}
                                    </MenuItem>
                                </Menu>
                            </>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const GetRejectReason = () => {
        CommentQuery.RejectPhotoReasonList()
            .then((res: any) => {
                if (res) {
                    let parseData = res.map((item: any) => {
                        return {
                            id: item.id,
                            reasonForRejection: item.reasonForRejection,
                            updateDate: (item.updateDate && TimeHelper.formatDate(item.updateDate)) || '-',
                            createDate: (item.createDate && TimeHelper.formatDate(item.createDate)) || '-',
                        };
                    });
                    setRejectReasonDatas(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    return (
        <div className={CRR_G.gridWrap} style={{ height: 600, width: '100%' }}>
            <div className={CRR_G.dataGridWrap}>
                <SCUICustomDataGrid rows={rejectReasonDatas} columns={columns} />
            </div>
        </div>
    );
};

export default CommentRejectReasonTable;
